module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "about-content padded"
  }, [_c('h3', {
    staticClass: "center"
  }, [_vm._v("About Grid Awesome")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("Quickly and easily create css "), _c('span', {
    staticStyle: {
      "color": "#428E9C"
    }
  }, [_vm._v("display"), _c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(":")]), _vm._v(" grid")]), _vm._v("; boilerplate.")])]), _vm._v(" "), _c('p', [_vm._v("Use Grid-Awesome to generate boilerplate css for grid layouts using the css "), _c('a', {
    attrs: {
      "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Grid_Layout"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#428E9C"
    }
  }, [_vm._v("display"), _c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(":")]), _vm._v(" grid")]), _vm._v(";")]), _vm._v(" property.")]), _vm._v(" "), _c('p', [_vm._v("Combined with media queries, completely customize the site layout with just a few lines of CSS (hide area 3 and change display order on mobile):")]), _vm._v(" "), _c('pre', [_vm._v("@supports (grid-area: auto) \n  /* mobile first */\n  .grid-container{\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto auto;\n    grid-template-areas:\n    \"area2\"\n    \"area1\"\n    \"area4\";\n  }\n  .area1 {\n    grid-area: area1;\n  }\n  .area2 {\n    grid-area: area2;\n  }\n  .area3 {\n    grid-area: area3;\n  }\n  .area4 {\n    grid-area: area4;\n  }\n\n  /* desktop */\n  @media screen and (min-width: 768px) {\n    .grid-container{\n      display: grid;\n      grid-template-columns: 3fr 4fr;\n      grid-template-rows: 10rem 15rem 20rem;\n      grid-template-areas:\n      \"area1 area1\"\n      \"area2 area3\"\n      \"area4 area4\";\n    }\n  }\n}")]), _vm._v("\nHTML:\n"), _c('pre', [_vm._v("<div class=\"grid-container\">\n  <div class=\"area1\"></div>\n  <div class=\"area2\"></div>\n  <div class=\"area3\"></div>\n  <div class=\"area4\"></div>\n</div>\n\n")])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "https://github.com/louisbourque/grid-awesome"
    }
  }, [_vm._v("View in GitHub")])]), _vm._v(" "), _c('div', {
    staticClass: "div--margintop"
  }, [_vm._v("Powered by "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/vue-logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "div--margintop"
  }, [_vm._v("Built by "), _c('a', {
    attrs: {
      "href": "http://louisbourque.ca/"
    }
  }, [_vm._v("Louis Bourque")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8819298","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 75
// module chunks = 1